'use client'

// a docs code block's copy control: THE copy disc (components/CopyDisc), come up on the block's hover
import CopyDisc from '../CopyDisc'

export default function CopyButton({ text }: { text: string }) {
  return <CopyDisc text={text} label="copy code" className="doc-copy" />
}
